/* eslint-disable no-unreachable */
import jwtDecode from "jwt-decode";

export function IsAuthenticated(token) {
  if (!token)
    return {
      isLogin: false,
      message: "Please login again",
    };
  // check if token is expired
  try {
    // sub: Username
    // exp: Expiration time
    // jti: UserOid
    // sid: EmployeeOid
    // iat: Employee Code
    // unique_name: EmployeeCode
    // nameid: RoleOid
    const {
      sub,
      exp,
      jti,
      EmployeeCode,
      unique_name: EmployeeName,
      sid: EmployeeOid,
      EmployeeLevel,
      IsDeclarant,
      Queryable,
      IsAllowRegOvt
    } = jwtDecode(token);
    if (exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      return {
        isLogin: false,
        message: "Session expired, please login again",
      };
    }
    return {
      isLogin: true,
      sub,
      jti,
      EmployeeCode,
      EmployeeName,
      EmployeeOid,
      EmployeeLevel,
      IsDeclarant,
      Queryable,
      message: "Success",
      IsAllowRegOvt
    };
  } catch (error) {
    // console.log("middleware/auth", error);
    return error;
  }
}
